import React from 'react'

const RefferalSingle = () => {
  return (
    <div>
      
    </div>
  )
}

export default RefferalSingle
